import React, { useCallback } from 'react'

import Button from '../Button'
import { Link, useHistory } from 'react-router-dom'

const LinkButtonComponent = React.forwardRef((props, ref) => {
  const {
    to,
    replace,
    canGoBack = true,
    back,
    onClick,
    navigate,
    ...buttonProps
  } = props
  const history = useHistory()

  const goBack = useCallback(() => {
    history.goBack()
  }, [history])

  const handleClick = useCallback(() => {
    if (back && canGoBack) {
      return goBack()
    }

    if (onClick) {
      return onClick()
    }
  }, [onClick, goBack, back, canGoBack])

  return <Button ref={ref} {...buttonProps} onClick={handleClick} />
})

export const LinkButton = ({ to = '#', ...props }) => {
  return <Link to={to} {...props} component={LinkButtonComponent} />
}

export default LinkButton
